import { FC } from "react";
import { Enum_Componentcmsdataproductslist_Displaytype } from "@/generated";
import SliderType from "./components/SliderType";
import BoxType from "./components/BoxType";
import { ProductListProps } from "./types";

const ProductList: FC<ProductListProps> = ({ displayType, ...props }) => {
  switch (displayType) {
    default:
    case Enum_Componentcmsdataproductslist_Displaytype.Slider: {
      return <SliderType {...props} />;
    }

    case Enum_Componentcmsdataproductslist_Displaytype.Box: {
      return <BoxType {...props} />;
    }
  }
};

export default ProductList;
